module.exports = __webpack_public_path__ + "static/media/heatSensitive.5d673b31.svg";